import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { headerEmpresa } from '../../helpers/headerEmpresa';
import { getEmpresa } from '../../../services/empresaService';

function formatNumber(value, decimals = 2) {
    return Number(value).toLocaleString('pt-BR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
}

async function VendasProdutoPDF(pedidos) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    // ✅ Busca dados da empresa
    const empresa = await getEmpresa();

    pedidos = Array.isArray(pedidos) ? pedidos : [];

    const reportTitle = {
        text: 'Relatório de Produtos Vendidos',
        fontSize: 20,
        bold: true,
        alignment: 'center',
        margin: [0, 10, 0, 20],
        color: '#333'
    };

    const totalQuantidade = pedidos.reduce(
        (acc, item) => acc + (parseFloat(item.QTOTAL) || 0),
        0
    );

    const totalValor = pedidos.reduce(
        (acc, item) => acc + (parseFloat(item.VTOTAL) || 0),
        0
    );

    const totalDesconto = pedidos.reduce(
        (acc, item) => acc + (parseFloat(item.TDESCONTO) || 0),
        0
    );

    const bodyData = pedidos.length
        ? pedidos.map(item => ([
            { text: item.COD_PRODUTO || 'N/A', fontSize: 10 },
            { text: item.DESCRICAO || 'N/A', fontSize: 10 },
            { text: item.UNIDADE || 'N/A', alignment: 'center', fontSize: 10 },
            { text: formatNumber(item.QTOTAL, 3), alignment: 'right', fontSize: 10 },
            { text: formatNumber(item.VTOTAL), alignment: 'right', fontSize: 10 }
        ]))
        : [[
            {
                text: 'Nenhum produto encontrado',
                colSpan: 5,
                alignment: 'center',
                italics: true
            },
            '', '', '', ''
        ]];

    const totalLine = [
        { text: 'Total Geral:', colSpan: 3, bold: true, fontSize: 11, alignment: 'right' },
        '',
        '',
        { text: formatNumber(totalQuantidade, 3), bold: true, alignment: 'right', fontSize: 11 },
        { text: formatNumber(totalValor), bold: true, alignment: 'right', fontSize: 11 }
    ];

    const details = {
        table: {
            headerRows: 1,
            widths: [90, '*', 60, 70, 60],
            body: [
                [
                    { text: 'Código', style: 'tableHeader' },
                    { text: 'Descrição', style: 'tableHeader' },
                    { text: 'Unidade', style: 'tableHeader', alignment: 'center' },
                    { text: 'Quantidade', style: 'tableHeader', alignment: 'right' },
                    { text: 'Valor Total', style: 'tableHeader', alignment: 'right' }
                ],
                ...bodyData,
                totalLine
            ]
        },
        layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? '#eeeeee' : null),
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
            hLineColor: () => '#aaa',
            vLineColor: () => '#aaa',
            paddingLeft: () => 5,
            paddingRight: () => 5,
            paddingTop: () => 4,
            paddingBottom: () => 4
        }
    };

    const docDefinitions = {
        pageSize: 'A4',

        // 🔹 margem maior por causa do header global
        pageMargins: [20, 60, 20, 40],

        // ✅ Cabeçalho padrão (empresa + data + hora)
        header: headerEmpresa(empresa),

        content: [
            reportTitle,
            details
        ],

        footer: (currentPage, pageCount) => ({
            columns: [
                {
                    text: `Gerado em: ${new Date().toLocaleDateString('pt-BR')}`,
                    fontSize: 9,
                    alignment: 'left',
                    margin: [20, 0, 0, 0]
                },
                {
                    text: `Página ${currentPage} de ${pageCount}`,
                    alignment: 'right',
                    fontSize: 9,
                    margin: [0, 0, 20, 0]
                }
            ]
        }),

        styles: {
            tableHeader: {
                bold: true,
                fontSize: 11,
                fillColor: '#f5f5f5'
            }
        }
    };

    pdfMake.createPdf(docDefinitions).open();
}

export default VendasProdutoPDF;
